import React, {Component} from 'react';
import {connect} from 'react-redux';
import {createLoadingSelector, getAccountDetails, getUserPermission} from "../../../../../../selectors";
import {getAllowedServiceLineStatusTransitions} from "../../../../../../actions/serviceLine.actions";
import {getServiceLineHistory} from '../../../../../../actions/accountDetailsActions/servicesAndEquipment.actions';
import {showModal} from "../../../../../../actions/modal.actions";
import {updateServicesUpdatedFlag} from "../../../../../../actions/globalFlag.actions";
import ServiceSummary from './ServiceSummary';
import isEmpty from "../../../../../../utils/helpers";
import moment from 'moment';
import Loader from "../../../../../../components/Loader";

export class ServiceWrapper extends Component {

    state = {
        service: this.props.service,
        isLoading: false,
        isExpanded: false,
        statusTransitions: null,
    }

    componentDidMount() {
        const {history, service} = this.props;

        // Reopen service line if going back from wizard
        if (history.location.state && history.location.state.serviceLineId === service.serviceLineId) {
            this.setState({isExpanded: true});

            // Wait for state update
            setTimeout(() => {

                // Scroll service line into view
                document.querySelectorAll('[data-line-id="'+service.serviceLineId+'"]')[0]
                    .scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});

                // Remove history state so we don't reopen/scroll again
                history.replace({state: undefined});

            }, 100);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        // If we just expanded the service line
        if (this.state.isExpanded && prevState.isExpanded !== this.state.isExpanded) {

            // Load historical data if toggle is on
            if (this.props.showHistoricalData) {
                this.setState({isLoading: true});
                this.props.getServiceLineHistory(this.props.service.serviceLineId).then(response => {
                    this.setState({
                        isLoading: false,
                        service: response,
                    });
                });
            } else {
                // We take serviceline num attribute and add it to service
                this.setState({isLoading: true});
                this.props.getServiceLineHistory(this.props.service.serviceLineId).then(response => {
                    let serviceWithServiceLineNums = this.props.service
                    serviceWithServiceLineNums.servicelineNums = response?.servicelineNums
                    this.setState({
                        isLoading: false,
                        service: serviceWithServiceLineNums,
                    });
                });
            }
        }
    }

    reloadAllowedServiceLineStatusTransitions = () => {
        const {accountId, service} = this.props;

        this.props.getAllowedServiceLineStatusTransitions(accountId, service.serviceLineId).then(response => {
            const statusTransitions = response.data.statusTransitions;

            if (statusTransitions) {
                statusTransitions.sort((a, b) => {
                    let compRes = a.order - b.order;

                    if (compRes === 0) {
                        compRes = a.description.localeCompare(b.description);
                    }

                    return compRes;
                });
            }

            this.setState({statusTransitions});
        });
    }

    handleCollapse = () => {
        this.setState((prevState) => ({
            isExpanded: !prevState.isExpanded
        }));

        // Hide dropdown
        if (!isEmpty(this.props.activeServiceLineDropdownId)) {
            this.props.handleActiveDropDown('serviceLine', this.props.activeServiceLineDropdownId);
        }
    };

    onSuccessfulStatusChangeHandler = () => {
        this.props.updateServicesUpdatedFlag();
    }

    onFailedStatusChangeHandler = (error) => {
    }

    showModal = (statusTransition) => {
        if (statusTransition.disabled) {
            return;
        }

        const {showModal, accountId, service} = this.props;

        showModal('SERVICE_LINE_STATUS_CHANGE_MODAL', {
            accountId,
            serviceLineId: service.serviceLineId,
            statusTransition,
            onSuccess: this.onSuccessfulStatusChangeHandler,
            onFail: this.onFailedStatusChangeHandler,
        });
    }

    handleAddEquipment = () => {
        const {accountId, service, handleActiveDropDown} = this.props;

        // Hide dropdown
        handleActiveDropDown('serviceLine', service.serviceLineId);

        // Gather wizard data
        let data = {
            wizardType: 'addEquipment',
            wizardData: {accountId, serviceLineId: service.serviceLineId}
        };

        // Show wizard
        this.props.showAddEquipmentWizardHandler(data);
    }

    handleRemoveEquipment = () => {
        const {accountId, service, handleActiveDropDown} = this.props;

        // Hide dropdown
        handleActiveDropDown('serviceLine', service.serviceLineId);

        // Gather wizard data
        let data = {
            wizardType: 'removeEquipment',
            wizardData: {accountId, serviceLineId: service.serviceLineId, serviceDevices: service.serviceDevices}
        };

        // Show wizard
        this.props.showRemoveEquipmentWizardHandler(data);
    }

    handleSwapEquipment = () => {
        const {accountId, service, handleActiveDropDown} = this.props;

        // Hide dropdown
        handleActiveDropDown('serviceLine', service.serviceLineId);

        // Gather wizard data
        let data = {
            wizardType: 'swapEquipment',
            wizardData: {accountId, serviceLineId: service.serviceLineId, serviceDevices: service.serviceDevices}
        };

        // Show wizard
        this.props.showSwapEquipmentWizardHandler(data);
    }

    allowValidateService = (service) => {
        let validate_service_devices = ["ADTN", "FREE_RADIUS_DEVICE"]
        if (!service.canEdit) {
            return false;
        } else if (isEmpty(service.serviceDevices)) {
            return false;
        } else {
            for (let idx=0; idx < service.serviceDevices.length; idx++) {
                let sd = service.serviceDevices[idx];
                if ((sd != null) && sd.canValidate) {
                    return true;
                }
            }
            return false;
        }
    }

    handleValidateService = () => {
        const {accountId, service, handleActiveDropDown} = this.props;

        // Hide dropdown
        handleActiveDropDown('serviceLine', service.serviceLineId);

        // Gather wizard data
        let data = {
            wizardType: 'validateService',
            wizardData: {accountId, serviceLineId: service.serviceLineId, serviceDevices: service.serviceDevices, service}
        };

        // Show wizard
        this.props.showValidateServiceWizardHandler(data);

    }

    renderAddressOrServiceLine = (service) => {
        if (service?.isDirectory &&
          (this.props.serviceModel.directorySystemNumType?.name === "PHONE_NUM" || this.props.serviceModel.directorySystemNumType?.name === "DN")) {
            return(
                <>
                    {service.number || "Service Line"}
                </>
            )
        } else {
            return(
                <>
                    {service.address2 ? service.address1 + ", " + service.address2 : service.address1}
                </>
            )
        }
    }

    render() {

        const {
            service,
            isLoading,
            isExpanded,
            statusTransitions,
        } = this.state;

        const {
            showHistoricalData,
            serviceLinesCount,
            directorySystemNumType,
            planId,
            accountPlanId,
            accountId,
            planDescription,
            serviceModelIcon,
            handleActiveDropDown,
            activeServiceLineDropdownId,
            handleProductAndPackagesClick,
            canEditServiceAddress,
            canViewCSIGeocode,
            canEditCSIGeocode,
            canChangeFeatures,
            canAddEquipment,
            canRemoveEquipment,
            canSwapEquipment,
            canValidateService,
            canUpdateBillingDate,
            canViewServiceLineAddress,
            equipmentPermissions,
            accountInfo,
        } = this.props;

        let serviceAgreementPeriodPercents = 0;

        if (!isEmpty(service)) {

            if (service.serviceLineAgreement) {
                const totalPeriod = moment(service.serviceLineAgreement.startDate)
                    .add(service.serviceLineAgreement.length, 'months')
                    .diff(moment(service.serviceLineAgreement.startDate), 'weeks');
                const fromStartPeriod = moment()
                    .diff(moment(service.serviceLineAgreement.startDate), 'weeks');
                serviceAgreementPeriodPercents = (fromStartPeriod / totalPeriod) * 100;

                if (serviceAgreementPeriodPercents === 0) {
                    serviceAgreementPeriodPercents = 1;
                }
            }
        }

        return (
            <>
                {service &&
                    <div className="service-wrapper" data-line-id={service.serviceLineId}>
                        <div className="service-header">

					<span
                        className={'service-title service-body-toggler' + (isExpanded ? '' : ' service-body-closed')}
                        onClick={this.handleCollapse}
                    >
                        {this.renderAddressOrServiceLine(service)}
                        {" "}
                        {"("}
                        {service.startDate && moment(service.startDate).format('MM/DD/YYYY')}
                        {" - "}
                        {service.endDate ? moment(service.endDate).format('MM/DD/YYYY') : "Now"}
                        {")"}
					</span>

                            <span className="service-toolbar">
						<span className="badge badge-outline-secondary">
                            {serviceLinesCount > 1 && service.planRelation}
						</span>
						<span className={"badge" + (
                            service.status === "Active" ? " badge-success"
                                : service.status === "Deactivated" ? " badge-danger"
                                    : " badge-secondary"
                        )}>
                            {service.status}
						</span>
                                    <span>

							<div className={"dropdown" + (activeServiceLineDropdownId === service.serviceLineId ? ' show' : '')}>
                                <button
                                    onClick={() => handleActiveDropDown('serviceLine', service.serviceLineId)}
                                    onBlur={() => handleActiveDropDown('serviceLine', service.serviceLineId, true)}
                                    className="btn-badge badge badge-secondary dropdown-toggle"
                                    role="button"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    <i className="fas fa-ellipsis-v"/>
                                </button>
								<div
                                    className={'dropdown-menu dropdown-menu-right' + (activeServiceLineDropdownId === service.serviceLineId ? ' show' : '')}
                                    aria-labelledby="dropdownMenuLink"
                                >
                                    {canChangeFeatures &&
                                        <button
                                            className="dropdown-item btn-change-oq-wizard"
                                            onMouseDown={() => {
                                                if (service.canEdit === true && service.status !== 'Deactivated') {
                                                    handleProductAndPackagesClick(planId, service.serviceLineId, service.planRelation, service.startDate)
                                                }
                                            }}
                                            disabled={!service.canEdit || service.status === 'Deactivated'}
                                        >
                                            Change Features
                                        </button>
                                    }

                                    {/*{directorySystemNumType &&*/}
                                    {/*    <button*/}
                                    {/*        className="dropdown-item"*/}
                                    {/*        disabled*/}
                                    {/*    >*/}
                                    {/*        Change {directorySystemNumType}*/}
                                    {/*    </button>*/}
                                    {/*}*/}

                                    <div className="dropdown-divider" />


                                    {canAddEquipment &&
                                        <button
                                            className="dropdown-item btn-change-oq-wizard"
                                            onMouseDown={this.handleAddEquipment}
                                            disabled={!service.canEdit || service.status === 'Deactivated'}
                                        >
                                            Add Equipment
                                        </button>
                                    }

                                    {canRemoveEquipment &&
                                        <button className="dropdown-item btn-change-oq-wizard"
                                                onMouseDown={this.handleRemoveEquipment}
                                                disabled={!service.canEdit || service.status === 'Deactivated' || isEmpty(service.serviceDevices)}
                                        >
                                            Remove Equipment
                                        </button>
                                    }

                                    {canSwapEquipment &&
                                        <>
                                            <button className="dropdown-item btn-change-oq-wizard"
                                                    onMouseDown={this.handleSwapEquipment}
                                                    disabled={!service.canEdit || service.status === 'Deactivated' || isEmpty(service.serviceDevices)}
                                            >
                                                Swap Equipment
                                            </button>
                                            <div className="dropdown-divider" />
                                        </>
                                    }


                                    {canValidateService &&
                                        <button className="dropdown-item btn-change-oq-wizard"
                                                onMouseDown={this.handleValidateService}
                                                disabled={service.status === 'Deactivated' || !this.allowValidateService(service)}
                                        >
                                            Validate Service
                                        </button>
                                    }

                                    <div className="dropdown-divider" />

                                    <button
                                        className="dropdown-item btn-change-oq-wizard"
                                        onMouseDown={() => {
                                            this.props.showModal('UPDATE_BILLING_DATE_MODAL', {
                                                accountPlanId: accountPlanId,
                                                planDescription: planDescription,
                                                serviceModelIcon: serviceModelIcon,
                                                serviceLineAddress: [
                                                    service.address1,
                                                    service.address2,
                                                    service.city,
                                                    service.state && service.state.abbreviation,
                                                    [service.zipCode, service.zip4].filter(Boolean).join('-'),
                                                ].filter(Boolean).join(', ') || 'Service Line',
                                                serviceLineNumber: service.number || '',
                                                accountId: accountId,
                                                serviceLineId: service.serviceLineId,
                                                currentStartDate: service.startDate,
                                                currentEndDate: service.endDate,
                                                accountInfo: accountInfo,
                                                showHistoricalData: showHistoricalData,
                                            });
                                        }}
                                        disabled={!canUpdateBillingDate || !['Active', 'Suspended', 'Deactivated'].includes(service.status) || !['Active', 'Suspended', 'Deactivated'].includes(accountInfo.status)}
                                    >
                                        Update Billing Dates
                                    </button>

								</div>
							</div>
						</span>
					</span>

                        </div>
                        {isExpanded && isLoading &&
                            <Loader />
                        }

                        {isExpanded && !isLoading &&
                            <div className={isExpanded ? 'service-body' : 'service-body collapse'}>
                                {(service.address1 || canEditServiceAddress) &&
                                    <div className="services-summary mt-0">
                                        <div className="services-summary-body">
                                            <div className="plan-wrapper">
                                                <div className="serviceline-wrapper">
                                                    <div className="plan-section">
                                                        <h5>Address</h5>
                                                        <div className="package-wrapper">
                                                            <div className="package-option">
                                                <span className="po-title">{service.address1}
                                                    {service.address2 ? ", " + service.address2 : ''}
                                                    {service.city ? ", " + service.city : ''}
                                                    {service.state ? (service.state.abbreviation ? ", " + service.state.abbreviation : '') : ''}
                                                    {service.zipCode ? ", " + service.zipCode : ''}
                                                    {service.zipCode && service.zip4 ? "-" + service.zip4 : ''}
                                                </span>
                                                                <span className="po-price"></span>
                                                                {canViewServiceLineAddress === true && service.status === "Active" &&
                                                                    <button
                                                                        onClick={() => this.props.showModal('SERVICE_ADDRESS_MODAL', {
                                                                            title: "Edit Service Address",
                                                                            id: service.serviceLineId,
                                                                            addressId: service.serviceLineAddressId,
                                                                            type: "SERVICE_LINE",
                                                                            service,
                                                                            canViewCSIGeocode,
                                                                            canEditCSIGeocode,
                                                                            isDisabled: !canEditServiceAddress
                                                                        })}
                                                                        className="btn btn-xs btn-outline-secondary btn-cn-edit">Edit</button>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }

                                <div className="service-usage">
                                    <div className="row">
                                        <div className="col-lg">
                                            <div className="cmv-progress-bar">

                                                <div className="progress-header">
										<span className="ph-left">
											<i className="far fa-fw fa-calendar-alt"/> Service Agreement
										</span>
                                                    {service.serviceLineAgreement ?
                                                        <span className="ph-right">
                                            {service.serviceLineAgreement.description},&nbsp;
                                                            {moment(service.serviceLineAgreement.startDate)
                                                                .format('MM/DD/YYYY')} &mdash;
                                                            {moment(service.serviceLineAgreement.startDate)
                                                                .add(service.serviceLineAgreement.length, 'months').format('MM/DD/YYYY')}
                                        </span>
                                                        :
                                                        <span className="ph-right">N/A</span>
                                                    }
                                                </div>

                                                <div className="progress">
                                                    {service.serviceLineAgreement && (
                                                        <div
                                                            className="progress-bar bg-info"
                                                            role="progressbar"
                                                            style={{width: serviceAgreementPeriodPercents + '%'}}
                                                            aria-valuenow="4"
                                                            aria-valuemin="0"
                                                            aria-valuemax="100"
                                                        />
                                                    )}
                                                </div>

                                                <div className="progress-footer">
                                                    {service.serviceLineAgreement && (
                                                        <p className="mb-0 text-right">
                                                            {moment(service.serviceLineAgreement.startDate)
                                                                .add(service.serviceLineAgreement.length, 'months')
                                                                .diff(moment(), 'weeks')
                                                            } weeks remaining
                                                        </p>
                                                    )}
                                                </div>

                                            </div>
                                        </div>
                                        <div className="col-lg">
                                            <div className="cmv-progress-bar">
                                                <div className="progress-header">
                                                    <span className="ph-left"><i className="far fa-fw fa-calendar-alt"/> Service Period</span>
                                                    <span className="ph-right">Started {moment(service.startDate).format('MM/DD/YYYY')}</span>
                                                </div>
                                                <div className="progress">
                                                    <div className="progress-bar bg-info" role="progressbar" style={{width: '100%'}} />
                                                </div>
                                                <div className="progress-footer">
                                                    <p className="mb-0 text-right">{moment().diff(moment(service.startDate), 'weeks')} weeks ago</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <ServiceSummary
                                    service={service}
                                    showHistoricalData={showHistoricalData}
                                />

                            </div>
                        }

                    </div>
                }
            </>
        );
    }
}

const getServiceLineStatusTransitionsLoader = createLoadingSelector(['GET_SERVICE_LINE_STATUS_TRANSITIONS']);

const mapStateToProps = (state) => {
    const accountInfo = getAccountDetails(state).accountDetails.accountInfo,
    accountId = accountInfo.id,
    canEditServiceAddress = getUserPermission(state, 'SERVICE_LINES', 'SERVICE_LINE_EDIT_ADDRESS_INFORMATION'),
    canViewCSIGeocode = getUserPermission(state, 'ADMN', 'ADMN_VIEW_CSI_GEOCODE'),
    canEditCSIGeocode = getUserPermission(state, 'ADMN', 'ADMN_EDIT_CSI_GEOCODE'),
    canChangeFeatures = getUserPermission(state, 'SERVICE_LINES', 'SERVICE_LINE_CHANGE_FEATURES'),
    canAddEquipment = getUserPermission(state, 'SERVICE_LINES', 'SERVICE_LINE_ADD_EQUIPMENT'),
    canRemoveEquipment = getUserPermission(state, 'SERVICE_LINES', 'SERVICE_LINE_REMOVE_EQUIPMENT'),
    canSwapEquipment = getUserPermission(state, 'SERVICE_LINES', 'SERVICE_LINE_SWAP_EQUIPMENT'),
    canValidateService = getUserPermission(state, 'SERVICE_LINES', 'SERVICE_LINE_VALIDATE_SERVICE'),
    canViewServiceLineAddress = getUserPermission(state, 'SERVICE_LINES', 'SERVICE_LINE_VIEW_ADDRESS_INFORMATION'),
    canUpdateBillingDate = getUserPermission(state, 'SERVICE_LINES', 'SERVICE_LINE_UPDATE_BILLING_DATE')

    let equipmentPermissions = [
        {canChangeFeatures},
        {canAddEquipment},
        {canRemoveEquipment},
        {canSwapEquipment},
        {canValidateService},
        {canUpdateBillingDate}
    ].filter((permission) => Object.values(permission)[0] === true)

    return {
        accountId,
        accountInfo,
        canEditServiceAddress,
        canViewCSIGeocode,
        canEditCSIGeocode,
        canChangeFeatures,
        canAddEquipment,
        canRemoveEquipment,
        canSwapEquipment,
        canValidateService,
        canUpdateBillingDate,
        equipmentPermissions,
        canViewServiceLineAddress
    };
};

const mapDispatchToProps = {
    getAllowedServiceLineStatusTransitions,
    showModal,
    updateServicesUpdatedFlag,
    getServiceLineHistory,
};

export default connect(mapStateToProps, mapDispatchToProps)(ServiceWrapper);
